import type {
  TaggableItemsFilterOptions,
  TaggableItemsSortOptions,
} from '@/modules/chatting/types'

export const taggableItemsSortOptions: {
  label: string
  value: TaggableItemsSortOptions
}[] = [
  { label: 'Recent', value: 'date' },
  { label: 'Name', value: 'name' },
]

export const taggableItemsFilterOptions: {
  label: string
  value: TaggableItemsFilterOptions
}[] = [
  { label: 'All', value: 'all' },
  { label: 'Pending', value: 'pending' },
]
